var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagIcon = function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m17.431 11.335 2.503-4.733a.75.75 0 0 0-.663-1.101h-6.583V4.14a.75.75 0 0 0-.75-.75H5.484V3a.75.75 0 0 0-1.5 0v18a.75.75 0 0 0 1.5 0v-5.883l5.706-.141v1.521c0 .202.082.396.226.537a.7.7 0 0 0 .542.213l7.331-.179a.75.75 0 0 0 .63-.374.75.75 0 0 0 .012-.732z",
    clipRule: "evenodd"
  })));
};
export default SvgFlagIcon;